import { EUserRoles } from 'modules/auth-session';

import {
  CommunicationsPageIcon,
  CompanyPageIcon,
  CompanyTypesPageIcon,
  DashboardPageIcon,
  DocumentsPageIcon,
  EecsGoPageIcon,
  ImagesPageIcon,
  PlatformDocumentationPageIcon,
  PlatformSettingsPageIcon,
  UsersPageIcon,
  WalletPageIcon,
} from 'components/Icons';

export const APP_NAVIGATION_LINKS = [
  {
    to: '/platform-dashboard',
    label: 'Dashboard',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
    icon: DashboardPageIcon,
  },
  {
    to: '/notifications',
    label: 'Notifications',
    alwaysHide: true,
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
  },
  {
    to: '/user-profile',
    label: 'User profile',
    alwaysHide: true,
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
  },
  {
    to: '/platform_settings',
    label: 'Platform Settings',
    roles_allowed: [EUserRoles.ADMIN],
    icon: PlatformSettingsPageIcon,
  },
  {
    to: '/docs',
    label: 'Platform Documentation',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
    icon: PlatformDocumentationPageIcon,
  },

  {
    to: '/communication',
    label: 'Communication',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
    icon: CommunicationsPageIcon,
  },
  {
    to: '/users',
    label: 'Users',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN],
    icon: UsersPageIcon,
  },
  {
    to: '/companies',
    label: 'Companies',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN],
    icon: CompanyPageIcon,
  },
  {
    to: '/company_types',
    label: 'Company Types',
    icon: CompanyTypesPageIcon,
  },
  {
    to: '/eecs-go',
    label: 'EECS GO',
    icon: EecsGoPageIcon,
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
  },
  {
    to: '/wallet',
    label: 'Wallet',
    icon: WalletPageIcon,
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
  },
  {
    to: '/documents',
    label: 'Documents',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
    icon: DocumentsPageIcon,
  },
  {
    to: '/images',
    label: 'Images',
    roles_allowed: [EUserRoles.ADMIN, EUserRoles.COMPANY_ADMIN, EUserRoles.USER],
    icon: ImagesPageIcon,
  },
];

export const mainMenuCategories = [
  {
    name: 'Exchange',
    links: ['/platform-dashboard', '/eecs-go', '/communication', '/wallet'],
  },
  {
    name: 'Administration',
    links: ['/users', '/companies', '/company_types', '/platform_settings'],
  },
  {
    name: 'Resources',
    links: ['/documents', '/images', '/docs'],
  },
  {
    name: 'Misc',
    links: ['/special_functions'],
  },
];

export const dictionary = {
  companies: { to: '/companies', label: 'Companies' },
  add: { to: '/add', label: 'Add' },
  edit: { to: '/edit', label: 'Edit', withParams: true },
  platform_settings: { to: '/platform_settings', label: 'Platform Settings' },
  special_functions: { to: '/special_functions', label: 'Special Functions' },
  destination_codes: { to: '/destination_codes', label: 'Destination QR codes' },
  branding: { to: '/branding', label: 'Branding' },
  users: { to: '/users', label: 'Users' },
  roles: { to: '/roles', label: 'Roles' },
  documents: { to: '/documents', label: 'Documents' },
  features: { to: '/features', label: 'Features' },
  questions: { to: '/mp-help-editor/questions', label: 'Questions' },
  'mp-help-editor': { to: '/mp-help-editor', label: 'Marketplace Help' },
  'mp-localization': { to: '/mp-localization', label: 'Marketplace Localization' },
  'eecs-go': { to: '/eecs-go', label: 'EECS GO' },
  'eecs-inventory': { to: '/eecs-inventory', label: 'EECS Inventory' },
  'eecs-forwards': { to: '/eecs-forwards', label: 'EECS Forwards' },
  'eecs-packages': { to: '/eecs-packages', label: 'EECS Packages' },
  'eecs-transactions': { to: '/eecs-transactions', label: 'EECS Transactions' },
  'eecs-pds': { to: '/eecs-pds', label: 'EECS Production Devices' },
  'necs-account': { to: '/necs-account', label: 'NECS Account' },
  'hknr-account': { to: '/hknr-account', label: 'HKNR Account' },
  'grex-denmark-account': { to: '/grex-denmark-account', label: 'G-REX Denmark (Energinet)' },
  'eecs-exchange-settings': { to: '/eecs-exchange-settings', label: 'Exchange Settings' },
  'eecs-registry-connections': { to: '/eecs-registry-connections', label: 'Registry Connections' },
  'eecs-cancellations': { to: '/eecs-cancellations', label: 'EECS Certificate Cancellations' },
  'eecs-payment-methods': { to: '/eecs-payment-methods', label: 'Payment Methods' },
  'manual-payment': { to: '/manual-payment', label: 'Payment by Invoice' },
  'wallet-payment': { to: '/wallet-payment', label: 'Wallet Payment' },
  'eecs-platform-fees': { to: '/eecs-platform-fees', label: 'Platform Fees' },
  'custom-notifications': { to: '/custom-notifications', label: 'Custom Notifications' },
  'standard-product': { to: '/standard-product', label: 'Standard Products' },
  'product-definitions': { to: '/product-definitions', label: 'Product Definitions' },
  'platform-dashboard': { to: '/platform-dashboard', label: 'Platform Dashboard' },
  terms: { to: '/terms', label: 'Terms & Conditions' },
};
